import {createSlice} from '@reduxjs/toolkit';

const initialState: null | {
    dates: {
        firstDate: any,
        secondDate: any,
        prevMonth: any,
        thisMonthYear: any,
    },
    data: any,
} = {
    dates: {
        firstDate: null,
        secondDate: null,
        prevMonth: null,
        thisMonthYear: null,
    },
    data: null,
};

const clientPaymentsSlice = createSlice({
    name: 'clientPayments',
    initialState,
    reducers: {
        setClientPayments(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
        clearClientPayments() {
            return initialState;
        },
    },
});

export const {setClientPayments, clearClientPayments} = clientPaymentsSlice.actions;

export default clientPaymentsSlice.reducer;